import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de0d176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "heaer-address" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_6 = { class: "m-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_goods_attr = _resolveComponent("goods-attr")!
  const _component_goods_list = _resolveComponent("goods-list")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_current_address, null, {
            address: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" > 学习专区 ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_goods_attr, {
        cid: _ctx.cid,
        aid: (_ctx.aid as string),
        onSetGoodsWhere: _ctx.setGoodsWhere
      }, null, 8, ["cid", "aid", "onSetGoodsWhere"]),
      (_ctx.freeWhere.params.cid > 0)
        ? (_openBlock(), _createBlock(_component_goods_list, {
            key: 0,
            cid: _ctx.freeWhere.params.cid,
            aids: _ctx.freeWhere.params.aids
          }, null, 8, ["cid", "aids"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_html_footer)
  ]))
}